import { AddPhotoAlternate, Close } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  LinearProgress,
  Paper,
  Typography,
} from "@mui/material";
import { UploadPicture } from "../redux/slices/payment";
import { useDispatch } from "react-redux";

export default function Upload({ stream, uploading, url, onRemove }) {
  const dispatch = useDispatch();

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith("image/")) {
      stream({ error: "Please select a valid image file" });
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      stream({ error: "Image size should be less than 5MB" });
      return;
    }

    // Show preview immediately
    const previewUrl = URL.createObjectURL(file);
    stream({ uploading: true, url: previewUrl }); // Clear previous error

    try {
      const res = await dispatch(UploadPicture(file));

      if (res) {
        stream({ uploading: false, url: res });
      } else {
        throw new Error("Upload failed");
      }
    } catch (err) {
      console.error("Upload error:", err);
      stream({ uploading: false, error: err.message });
    }
  };

  return (
    <>
      {!url ? (
        <Button
          variant="outlined"
          component="label"
          fullWidth
          disabled={uploading}
          startIcon={<AddPhotoAlternate />}
          sx={{
            py: 2,
            borderRadius: 2,
            borderStyle: "dashed",
            borderWidth: 2,
          }}
        >
          Select Image
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </Button>
      ) : (
        <Box position="relative">
          <Paper
            elevation={2}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              position: "relative",
            }}
          >
            <img
              src={url}
              alt="Preview"
              style={{
                width: "100%",
                height: 280,
                objectFit: "cover",
              }}
            />
            {!uploading && (
              <IconButton
                onClick={onRemove}
                disabled={uploading}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  bgcolor: "error.main",
                  color: "white",
                  "&:hover": {
                    bgcolor: "error.dark",
                  },
                  boxShadow: 2,
                }}
                size="small"
              >
                <Close />
              </IconButton>
            )}
          </Paper>
        </Box>
      )}

      {uploading && (
        <Box mt={2}>
          <LinearProgress />
          <Typography
            variant="caption"
            color="text.secondary"
            mt={1}
            display="block"
          >
            Uploading image...
          </Typography>
        </Box>
      )}
    </>
  );
}
